import React from 'react';
import arrowButton from './arrow-btn.png';

const Button = ({ text, clickHandler, ...rest }) => (
  <button type="submit" onClick={clickHandler} {...rest}>{text}</button>
);

const PrimaryButton = (props) => (<Button className="button is-primary is-medium is-uppercase" {...props} />);
const NonPrimaryButton = (props) => (<Button className="button is-medium is-uppercase" {...props} />);
export const LinkButton = ({ url, text, ...rest }) => (<a href={url} target="_blank" className="button is-primary is-medium is-uppercase">{text}</a>);
export const NextButton = ({ next, text="Next", ...rest }) => <PrimaryButton clickHandler={() => { next(); }} text={text} {...rest} />;
export const BackButton = ({ back, text="Back", ...rest }) => <NonPrimaryButton clickHandler={() => { back(); }} text={text} {...rest} />;

// for progress bar
export const AdvanceButton = ({ next, advance, text="Next", ...rest }) => (
  <PrimaryButton clickHandler={() =>  { advance(); next(); }} text={text} {...rest} />
);
export const RevertButton = ({ back, revert, text="Back", ...rest }) => (
  <NonPrimaryButton clickHandler={() => { revert(); back(); }} text={text} {...rest} />
);

export const BrowseButton = ({ url }) => (
  <a href={url} target="_blank"><span className="browse-btn">Browse <img src={arrowButton} alt=""/></span></a>
);


// WEBPACK FOOTER //
// ./src/components/buttons/index.js